import {profileActionTypes} from './profile.actionTypes';

const initialState = {
  ld_profile: false,
  er_profile: null,
  profileData: null,
  BankDetailsData: null,
  referralData: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case profileActionTypes.SET_PROFILE: {
      return {
        ...state,
        ld_profile: false,
        profileData: action.payload,
        er_profile: null,
      };
    }
    case profileActionTypes.SET_PROFILE_ERROR: {
      return {
        ...state,
        ld_profile: false,
        profileData: null,
        er_profile: action.error,
      };
    }
    case profileActionTypes.SET_BANK_DETAILS: {
      return {
        ...state,
        BankDetailsData: action.payload,
      };
    }
    case profileActionTypes.SET_BANK_DETAILS_ERROR: {
      return {
        ...state,
        BankDetailsData: action.error,
      };
    }
    case profileActionTypes.SET_REFERRAL_DATA: {
      return {
        ...state,
        referralData: action.payload,
      };
    }
    case profileActionTypes.SET_REFERRAL_ERROR: {
      return {
        ...state,
        referralData: action.error,
      };
    }
    default: {
      return state;
    }
  }
};

export {reducer as profileReducer};
